import React, { useState, useEffect } from 'react'
import {
    Box,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    TextField,
    Typography,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    LinearProgress,
    Autocomplete, Dialog, Paper,
    Snackbar,
    Alert
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import axios from 'axios';
import { axiosInstance, localAxiosGet, localAxiosToken } from '../../../Axios/axios';
import { styled } from '@mui/material/styles';
import { set } from 'date-fns';

const StyledDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        borderRadius: '12px',
        padding: theme.spacing(2),
        minWidth: '500px'
    }
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(3),
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
    height: '100%',
    background: 'linear-gradient(135deg, #E3EEFF 0%, #F3E7FF 100%)',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 6px 24px rgba(59, 130, 246, 0.2)'
    }
}));


const CreateProject = ({ open, onClose, onProjectCreateSuccess }) => {

    const [newProject, setNewProject] = useState({
        name: '',
        client: '',
        projectManager: null,
        teamLead: null,
        startDate: null,
        endDate: null,
        status: 'Todo',
        description: '',
        priority: 'Medium',
        progress: '',
        manager_id: null,
        team_leader_id: null
    });
    const [teamLeadOptions, setTeamLeadOptions] = useState([]);
    const [managerOptions, setmanagerOptions] = useState([]);
    const [managerInputValue, setManagerInputValue] = useState('');
    const [leadInputValue, setLeadInputValue] = useState('');
    const organizationId = localStorage.getItem('organizationId');
    const [isLoading, setIsLoading] = useState(false);
    const accessToken = localStorage.getItem('accessToken');
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    //Load the team leaders and project maanger drop down form the apis on mount of the component
    useEffect(() => {
        const fetchData = async () => {
            try {
                const teamLeadresponse = await axiosInstance(localAxiosGet(`/project/getAllTeamLeadOrManager?organization_id=${organizationId}&is_team_lead=true`, accessToken));
                // console.log('Response data:', teamLeadresponse.data);

                if (teamLeadresponse.data && teamLeadresponse.data.message && teamLeadresponse.data.message.users) {
                    const options = teamLeadresponse.data.message.users.map(user => ({
                        id: user.id,
                        name: `${user.first_name} ${user.last_name}`
                    }));
                    setTeamLeadOptions(options);
                    // console.log('teamleadoptions', options);
                }

                const managerResponse = await axiosInstance(localAxiosGet(`/project/getAllTeamLeadOrManager?organization_id=${organizationId}&is_manager=true`, accessToken));

                if (managerResponse.data && managerResponse.data.message && managerResponse.data.message.users) {
                    const options = managerResponse.data.message.users.map(user => ({
                        id: user.id,
                        name: `${user.first_name} ${user.last_name}`
                    }));
                    setmanagerOptions(options);
                    // console.log('manager options', options);
                }

            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
        fetchData();
    }, [open])


    //Create project API
  const handleCreateProject = async () => {
    // if(!newProject.project_title || newProject.client ||!newProject.projectManager || !newProject.teamLead || !newProject.manager_id || !newProject.team_leader_id){
        
    //         setSnackbar({ open: true, message: 'Please fill in all required fields.', severity: 'warning' });
    //         return;
    //     }
    setIsLoading(true);
    try {
        if (newProject.name && newProject.client && newProject.startDate && newProject.endDate) {

            const newProjectItem = {
                ...newProject,
                startDate: newProject.startDate.toISOString(),
                endDate: newProject.endDate.toISOString(),
                teamMembers: []
            };

            const requriedData = {
                organization_id: organizationId,
                project_title: newProject.name,
                priority: newProject.priority,
                start_date: newProjectItem.startDate,
                end_date: newProjectItem.endDate,
                description: newProject.description,
                clients: (() => {
                    if (newProject.client && newProject.client.trim() !== '') {
                        const clientNameParts = newProject.client.trim().split(' ');
                        if (clientNameParts.length >= 2) {
                            return [{
                                first_name: clientNameParts[0],
                                last_name: clientNameParts.slice(1).join(' ')
                            }];
                        } else {
                            return [{
                                first_name: newProject.client.trim(),
                                last_name: ''
                            }];
                        }
                    } else {
                        return [];
                    }
                })(),
                status: newProject.status,
                progress: newProject.progress || 0,
                manager_id: newProject.manager_id,
                team_leader_id: newProject.team_leader_id,
            }

            try {
                const config = localAxiosToken(`/project/createProject`, requriedData);
                const response = await axiosInstance(config.url, config);

                if (response.data && response.data.status === 'SUCCESS') {
                    // Show success snackbar first
                    setSnackbar({ 
                        open: true, 
                        message: response.data.message.message || 'Project created successfully!', 
                        severity: 'success' 
                    });
                    
                    // Then close the window and reset form after a short delay
                    setTimeout(() => {
                        onProjectCreateSuccess();
                        onClose();
                        // Reset form
                        setNewProject({
                            name: '',
                            client: '',
                            projectManager: null,
                            teamLead: null,
                            startDate: null,
                            endDate: null,
                            status: 'Todo',
                            description: '',
                            priority: 'Medium',
                            progress: '',
                            manager_id: null,
                            team_leader_id: null
                        });
                        setIsLoading(false);
                    }, 500); 
                    
                } else if (response.data.status === 'FAILED') {
                    // Handle the case where message is an object with error property
                    const errorMessage = typeof response.data.message === 'object' 
                        ? response.data.message.error 
                        : response.data.message;
                    setSnackbar({ open: true, message: errorMessage || 'Failed to create project.', severity: 'error' });
                    setIsLoading(false); // Stop loading on error
                }
            } catch (error) {
                console.error('Error in creating the project', error.response ? error.response.data : error.message);
                // Handle nested error objects properly
                const errorData = error?.response?.data;
                let errorMessage = 'Error creating project. Please try again.';
                
                if (typeof errorData?.message === 'object' && errorData.message.error) {
                    errorMessage = errorData.message.error;
                } else if (errorData?.message) {
                    errorMessage = errorData.message;
                } else if (errorData?.error) {
                    errorMessage = errorData.error;
                }
                
                setSnackbar({ open: true, message: errorMessage, severity: 'error' });
                setIsLoading(false); // Stop loading on error
            }

        } else {
            setSnackbar({ open: true, message: 'Please fill in  required fields.Include start and end date also', severity: 'warning' });
            setIsLoading(false);
        }
    } catch (error) {
        console.error('Error creating project:', error);
        setSnackbar({ open: true, message: 'Error creating project. Please try again.', severity: 'error' });
        setIsLoading(false);
    }
};

const handleCancelButton = () => {
    setNewProject({
        name: '',
        client: '',
        startDate: null,
        endDate: null,
        status: 'Todo',
        description: '',
        priority: 'Medium',
        progress: 0
    });
    onClose();
}
return (
    <StyledDialog
        open={open}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
            sx: {
                background: 'linear-gradient(to right bottom, #ffffff, #f8f9ff)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            }
        }}
    >
        <Box sx={{ width: { xs: '90%', md: '100%' }, mx: 'auto' }}> {/* Added Box for DialogTitle */}
            <DialogTitle>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    // mb: 1,
                    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                    p: 2,
                    borderRadius: '12px',
                    color: 'white'
                }}>
                    <AddIcon sx={{ mr: 1, color: 'white', fontSize: 28 }} />
                    <Typography variant="h5" component="span" sx={{ fontWeight: 600 }}>
                        Create New Project
                    </Typography>
                </Box>
            </DialogTitle>
        </Box>

        <Box sx={{ width: { xs: '90%', md: '100%' }, mx: 'auto' }}> {/* Added Box for DialogContent */}
            <DialogContent >
                <Grid container spacing={1.5} >

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Project Name"
                            fullWidth
                            required
                            value={newProject.name}
                            onChange={(e) => setNewProject({ ...newProject, name: e.target.value })}
                            InputProps={{
                                sx: {
                                    borderRadius: '8px',
                                    '&:hover': {
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#3b82f6'
                                        }
                                    }
                                }
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#3b82f6'
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: '#3b82f6'
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            label="Client"
                            fullWidth
                            required
                            value={newProject.client}
                            onChange={(e) => setNewProject({ ...newProject, client: e.target.value })}
                            InputProps={{
                                sx: {
                                    borderRadius: '8px',
                                    '&:hover': {
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#3b82f6'
                                        }
                                    }
                                }
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#3b82f6'
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: '#3b82f6'
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            options={managerOptions}
                            getOptionLabel={(option) => option.name}
                            inputValue={managerInputValue}
                            onInputChange={(event, newInputValue) => {
                                setManagerInputValue(newInputValue);
                            }}
                            value={newProject.projectManager}
                            onChange={(event, newValue) => {
                                const managerId = newValue ? newValue.id : null;
                                setNewProject({ ...newProject, projectManager: newValue, manager_id: managerId });
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Project Manager"
                                    fullWidth
                                    required
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px',
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#3b82f6'
                                            }
                                        },
                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#3b82f6'
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: '#3b82f6'
                                        }
                                    }}
                                />
                            )}
                        />
                    </Grid>


                    <Grid item xs={12} sm={6}>
                        <Autocomplete
                            options={teamLeadOptions}
                            getOptionLabel={(option) => option.name}
                            inputValue={leadInputValue}
                            onInputChange={(event, newInputValue) => {
                                setLeadInputValue(newInputValue);
                            }}
                            value={newProject.teamLead}
                            onChange={(event, newValue) => {
                                const teamLeadId = newValue ? newValue.id : null;
                                setNewProject({ ...newProject, teamLead: newValue, team_leader_id: teamLeadId });
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Team Lead"
                                    fullWidth
                                    required
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '8px',
                                            '&:hover .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#3b82f6'
                                            }
                                        },
                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#3b82f6'
                                        },
                                        '& .MuiInputLabel-root.Mui-focused': {
                                            color: '#3b82f6'
                                        }
                                    }}
                                />
                            )}
                        />
                    </Grid>


                    <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label="Start Date"
                                value={newProject.startDate}
                                format="dd/MM/yyyy"
                                onChange={(date) => setNewProject({ ...newProject, startDate: date })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        required
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#3b82f6'
                                                }
                                            },
                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#3b82f6'
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: '#3b82f6'
                                            }
                                        }}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label="End Date"
                                value={newProject.endDate}
                                minDate={newProject.startDate}
                                format="dd/MM/yyyy"
                                onChange={(date) => setNewProject({ ...newProject, endDate: date })}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        fullWidth
                                        required
                                        sx={{
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#3b82f6'
                                                }
                                            },
                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                borderColor: '#3b82f6'
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: '#3b82f6'
                                            }
                                        }}
                                    />
                                )}
                            />
                        </LocalizationProvider>
                    </Grid>


                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel sx={{ '&.Mui-focused': { color: '#3b82f6' } }}>Priority</InputLabel>
                            <Select
                                value={newProject.priority}
                                label="Priority"
                                onChange={(e) => setNewProject({ ...newProject, priority: e.target.value })}
                                sx={{
                                    borderRadius: '8px',
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#3b82f6'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#3b82f6'
                                    }
                                }}
                            >
                                <MenuItem value="Low" sx={{ color: '#4caf50' }}>Low</MenuItem>
                                <MenuItem value="Medium" sx={{ color: '#ff9800' }}>Medium</MenuItem>
                                <MenuItem value="High" sx={{ color: '#f44336' }}>High</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            label="Description"
                            fullWidth
                            multiline
                            rows={3}
                            value={newProject.description}
                            onChange={(e) => setNewProject({ ...newProject, description: e.target.value })}
                            InputProps={{
                                sx: {
                                    borderRadius: '8px',
                                    '&:hover': {
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            borderColor: '#3b82f6'
                                        }
                                    }
                                }
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#3b82f6'
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: '#3b82f6'
                                }
                            }}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{
                            p: 2,
                            borderRadius: '12px',
                            background: 'linear-gradient(to right, #f8f9ff, #ffffff)',
                            border: '1px solid #e0e7ff'
                        }}>
                            <Typography variant="subtitle2" gutterBottom sx={{ color: '#3b82f6', fontWeight: 600 }}>
                                Project Progress
                            </Typography>
                            <LinearProgress
                                variant="determinate"
                                value={newProject.progress}
                                sx={{
                                    height: 10,
                                    borderRadius: 5,
                                    backgroundColor: '#e0e7ff',
                                    '& .MuiLinearProgress-bar': {
                                        background: 'linear-gradient(to right, #3b82f6, #2563eb)'
                                    }
                                }}
                            />
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                                <Typography variant="caption" sx={{ color: '#64748b' }}>0%</Typography>
                                <Typography variant="caption" sx={{ color: '#64748b' }}>100%</Typography>
                            </Box>
                            <TextField
                                type="number"
                                label="Progress Percentage"
                                value={newProject.progress}
                                onChange={(e) => setNewProject({
                                    ...newProject,
                                    progress: e.target.value === '' ? '' : Math.min(100, Math.max(0, parseInt(e.target.value) || 0))
                                })}
                                InputProps={{
                                    inputProps: { min: 0, max: 100 },
                                    sx: { borderRadius: '8px' }
                                }}
                                sx={{
                                    mt: 1,
                                    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#3b82f6'
                                    },
                                    '& .MuiInputLabel-root.Mui-focused': {
                                        color: '#3b82f6'
                                    }
                                }}
                                fullWidth
                            />
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
        </Box>

        <DialogActions sx={{ p: 3, background: '#f8f9ff' }}>
            <Button
                onClick={handleCancelButton}
                variant="outlined"
                sx={{
                    borderRadius: '8px',
                    textTransform: 'none',
                    borderColor: '#94a3b8',
                    color: '#94a3b8',
                    px: 4,
                    '&:hover': {
                        borderColor: '#64748b',
                        backgroundColor: 'transparent'
                    }
                }}
            >
                Cancel
            </Button>
            <Button
                onClick={handleCreateProject}
                variant="contained"
                sx={{
                    borderRadius: '8px',
                    textTransform: 'none',
                    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                    px: 4,
                    '&:hover': {
                        background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)'
                    }
                }}
            >
                Create Project
            </Button>
        </DialogActions>

        <Snackbar
            open={snackbar.open}
            autoHideDuration={6000}
            onClose={() => setSnackbar({ ...snackbar, open: false })}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
            <Alert
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                severity={snackbar.severity}
                sx={{ width: '100%' }}>
                {snackbar.message}
            </Alert>
        </Snackbar>
    </StyledDialog>
)
}

export default CreateProject;